import { CommonButton } from 'components/Button'
import { Font14 } from 'components/Typography/Labels'
import styled from 'styled-components'
import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'

export const SubscriptionStatusDashboardWrapper = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SubscriptionStatusInformationContainer = styled.div<{
  isSuccess: boolean
}>`
  padding: 10px 16px;
  background: ${({ isSuccess }) =>
    isSuccess ? 'rgba(35, 197, 20, 0.1)' : 'rgba(197, 41, 42, 0.1)'};
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  justify-content: center;

  > p {
    margin: 0;
  }

  ${CommonButton} {
    width: 100%;
  }

  @media ${theme.devices.tablet} {
    gap: 20px;
    justify-content: initial;
    padding: 12px 16px;

    ${CommonButton} {
      width: initial;
    }
  }
`

export const SubscriptionStatusInformationText = styled.p`
  ${Font14};
  flex: 1;
`

export const SubscriptionStatusButton = styled(CommonButton)`
  @media ${theme.devices.tablet} {
    display: initial;
  }

  @media ${theme.devices.mobile} {
    display: initial;
    order: 0;
  }
`
export const SubscriptionStatusHeaderButton = styled(CommonButton)`
  @media ${theme.devices.tablet} {
    display: none;
  }
`
